import React, { ReactElement, ReactNode, useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import * as clipboard from 'clipboard-polyfill';

export type PropsDeCopie = { children: ReactNode; texte: string | clipboard.ClipboardItemInterface };

export function CopierPressePapier({ children, texte }: PropsDeCopie): ReactElement {
    const item = typeof texte == 'string' ? new clipboard.ClipboardItem({ 'text/plain': texte }) : texte;
    const [show, setShow] = useState(false);
    const target = useRef(null);

    const [isCopying, setIsCopying] = useState(false);

    return (
        <>
            <span
                ref={target}
                style={{ cursor: 'pointer', opacity: isCopying ? 0.5 : 1 }}
                onClick={async (e) => {
                    if (!isCopying) {
                        e.preventDefault();
                        setIsCopying(true);
                        try {
                            await clipboard.write([item]);
                            setShow(true);
                            setTimeout(() => {
                                setShow(false);
                                setIsCopying(false);
                            }, 1000);
                        } catch (err) {
                            console.error('Erreur lors de la copie :', err);
                            setIsCopying(false);
                        }
                    }
                }}
            >
                {children}
            </span>
            {target.current && (
                <Overlay target={target.current} show={show} placement="bottom">
                    {(props) => (
                        <Tooltip id="overlay-presse-papier" {...props}>
                            Copié!
                        </Tooltip>
                    )}
                </Overlay>
            )}
        </>
    );
}
